import React from "react";
import "../styles/Messages.css";

// ✅ Import Photos
import founderImg from "../Assets/Images/akij-uddin.png";
import cofounderImg from "../Assets/Images/woman-placeholder..jpg";
import presidentImg from "../Assets/Images/jamil-sir.jpg";
import principalImg from "../Assets/Images/shahdat.jpg";

const messages = [
  {
    id: 1,
    name: "Sk. Akij Uddin",
    // title: "Founder's Message",
    message: (
      <>
        <p>
          দেশের অর্থনৈতিক পরিবর্তন ঘটানোর ক্ষেত্রে কারিগরি শিক্ষা অপরিহার্য।
          আমাদের যুব সমাজকে দক্ষ জনশক্তিতে পরিণত করতে এই প্রতিষ্ঠান তার ভূমিকা
          রাখবে—এই আমার দৃঢ় বিশ্বাস।
        </p>
        <p>
          আমি আশা করি, ভবিষ্যৎ প্রজন্ম এই প্রতিষ্ঠানের ঐতিহ্য, সততা ও পরিশ্রমের
          মূল্যবোধকে ধরে রাখবে এবং দেশ ও জাতির কল্যাণে অবদান রাখবে।
        </p>
      </>
    ),
    
    image: founderImg,
    position: "Founder - Akij Group",
    lifespan: "(1929–2006)",
  },

  {
    id: 2,
    name: "Mrs. Monowara Begum",
    // title: "Chairman's Message",
    message: (
      <>
        <p>
          বাংলাদেশের প্রচলিত শিক্ষা ব্যবস্থা বিভিন্ন পদ্ধতিতে হওয়ায় দেশের কর্মসংস্থানের
          সাথে শিক্ষার সমন্বয় ঘটানো অত্যন্ত কঠিন। একদিকে শিক্ষার্থীরা নামে মাত্র ডিগ্রী
          অর্জন করছে অন্যদিকে উদ্যোক্তারা যোগ্য ও দক্ষ জনবল পাচ্ছে না। ফলে
          জাতীয় ও আন্তর্জাতিক ভাবে দেশের বাণিজ্য বাজার ধ্বংস হচ্ছে।
        </p>
        <p>
          তাই দেশের শিক্ষা ব্যবস্থার সাথে অত্যাবশ্যকীয় ভাবে কারিগরি শিক্ষাকে অন্তর্ভুক্ত
          করে দক্ষ ও যোগ্য কর্মীবান্ধব করে তুলতে হবে। কারিগরি শিক্ষা ও প্রশিক্ষণ
          সঠিকভাবে প্রদান করা হলে দেশের চাহিদা মিটিয়ে আন্তর্জাতিক বাজারেও বড়
          ভূমিকা পালন করবে।
        </p>
      </>
    ),
    
    image: cofounderImg,
    position: "Chairman - Akij Welfare Trust",
    // lifespan: "(Sk. Akij Uddin's wife)",
  },

  {
    id: 3,
    name: "Sk Jamil Uddin",
    // title: "President's Message",
    message: (
      <>
        <p>
          দেশের অর্থনৈতিক পরিবর্তন ঘটানোর ক্ষেত্রে কারিগরি শিক্ষা অপরিহার্য।
          আমাদের যুব সমাজকে দক্ষ জনশক্তিতে পরিণত করতে এই প্রতিষ্ঠান তার ভূমিকা
          রাখবে—এই আমার দৃঢ় বিশ্বাস।
        </p>
        <p>
          আমি আশা করি, ভবিষ্যৎ প্রজন্ম এই প্রতিষ্ঠানের ঐতিহ্য, সততা ও পরিশ্রমের
          মূল্যবোধকে ধরে রাখবে এবং দেশ ও জাতির কল্যাণে অবদান রাখবে।
        </p>
      </>
    ),
    image: presidentImg,
    position: "Managing Director - Akij Insaf Ltd.",
  },

  // {
  //   id: 4,
  //   name: "Md. Shahdat Hossain",
  //   // title: "Principal's Message",
  //   message: (
  //     <>
  //       <p>
  //         বাংলাদেশ একটি জনবহুল দেশ. এই দেশের প্রচলিত শিক্ষা ব্যবস্থা বিভিন্ন
  //         পদ্ধতিতে হওয়ায় দেশের কর্মসংস্থানের সাথে শিক্ষার সমন্বয় ঘটানো অত্যন্ত
  //         কঠিন.একদিকে শিক্ষার্থীরা নামে মাত্র ডিগ্রী অর্জন করছে অন্যদিকে উদ্যোক্তারা
  //         যোগ্য ও দক্ষ জনবল পাচ্ছে না. ফলে জাতীয় ও আন্তর্জাতিক ভাবে দেশের
  //         বাণিজ্য বাজার ধ্বংস হচ্ছে. আর সুবিধাবঞ্চিত মানুষ তার ন্যায্য অধিকার না
  //         পেয়ে রয়েই যাচ্ছে দরিদ্র সীমার নিচে.
  //       </p>
  //       <p>
  //         এই প্রেক্ষাপট থেকে উত্তোলনের জন্য কারিগরি শিক্ষার কোন বিকল্প নেই.
  //         ফলে দেশের শিক্ষা ব্যবস্থার সাথে অত্যাবশ্যকীয় ভাবে কারিগরি শিক্ষাকে
  //         অন্তর্ভুক্ত করে দক্ষ ও যোগ্য কর্মীবান্ধব করে তুলতে হবে. কারণ বর্তমান
  //         প্রযুক্তি ও শিল্পায়নের যুগে সাধারণ শিক্ষা ব্যবস্থা দেশের জন্য কোন সুফল
  //         বয়ে আনতে পারবে না বরং তা দেশের জন্য বোঝা হচ্ছে.
  //       </p>
  //       <p>
  //         কারিগরি শিক্ষা ও প্রশিক্ষণ সঠিকভাবে প্রদান করা হলে দেশের চাহিদা মিটিয়ে
  //         আন্তর্জাতিক বাজারেও বড় ভূমিকা পালন করবে. ফলে দেশ ও দেশের বাইরে
  //         বাংলাদেশ একটি উন্নত দেশ হিসেবে প্রসিদ্ধতা লাগবে. তাই আমাদের প্রতিটি
  //         মানুষের কারিগরি শিক্ষার প্রতি সচেতন হওয়া প্রয়োজন.
  //       </p>
  //     </>
  //   ),
  //   image: principalImg,
  //   position: "Principal - Akij Foundation Vocational School",
  // },
];

export default function Messages() {
  return (
    <div className="messages-page">
      {messages.map((msg, index) => (
        <div
          key={msg.id}
          className={`message-section ${
            index % 2 === 0 ? "reverse-layout" : ""
          }`}
        >
          <div className="message-image-wrapper">
            <div className="image-square">
              <img src={msg.image} alt={msg.name} className="message-img" />
            </div>
            <div className="message-name">
              <p>
                <strong>
                  {msg.name} {msg.lifespan}
                </strong>
                <br />
                {msg.position}
              </p>
            </div>
          </div>

          <div className="message-text">
            <p className="intro">{msg.name}</p>
            <h1 className="title">{msg.title}</h1>
            <div className="statement">{msg.message}</div>
          </div>
        </div>
      ))}
      
    </div>
  );
}
